export interface Participant {
  id: string;
  tournamentId: string;
  name: string;
  seed: number;
  userId?: string;
  userEmail?: string;
  createdAt: Date;
  updatedAt: Date;
}